// src/routes/ProtectedRoute.jsx
// Gates a route on auth and optionally on role. Unauthenticated -> /login.
// Wrong role -> bounced to that user's own home so nobody sees another
// role's surface.

import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { homePathForRole } from "../config";

export default function ProtectedRoute({ allow }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen grid place-items-center bg-tb-bg dark:bg-tb-night">
        <div className="h-6 w-6 rounded-full border-2 border-tb-brand border-t-transparent animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (allow && !allow.includes(user.role)) {
    return <Navigate to={homePathForRole(user.role)} replace />;
  }

  return <Outlet />;
}
